import { useContext } from 'react';

import { QuoteContext } from './QuoteContextProvider.context';
import { QuoteContextState } from './QuoteContextProvider.types';

export const useQuoteContext = <C extends QuoteContextState>(): C => {
  const context = useContext(QuoteContext) as unknown as C | null;
  if (!context) {
    throw new Error('useQuoteContext must be used within a QuoteContextProvider');
  }
  return context;
};
